import { api } from '@/lib/api/client';
import { API_CONFIG } from '@/config';

export async function handleFileUpload(
  file: File, 
  maxSize: number,
  onError?: (error: string) => void
): Promise<string | null> {
  if (file.size > maxSize) {
    onError?.(`الملف كبير جداً. الحد الأقصى هو ${Math.round(maxSize / (1024 * 1024))}MB`);
    return null;
  }

  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', file.type.startsWith('image/') ? 'image' : 'pdf');

    const response = await api.post<{ url: string }>(
      API_CONFIG.ENDPOINTS.UPLOAD,
      formData
    );

    return response.url;
  } catch (error) {
    console.error('Upload error:', error);
    onError?.('حدث خطأ أثناء رفع الملف');
    return null;
  }
}